
import { Component } from "vue-property-decorator";
import IconList from '@components/icons/icon-list.svg';
import IconStatistic from "@components/icons/icon-statistic.svg";
import IconCarHealth from "@components/icons/icon-car-health.svg";
import Vue from "vue";

@Component({
  name: 'NavigationSidebar',
  components: {
    IconList,
    IconStatistic,
    IconCarHealth,
  },
})
export default class NavigationSidebar extends Vue {
  private tripTabs = ['myTrips', 'myTripsEdit', 'myTripsAdd', 'fuelStopEdit', 'fuelStopAdd']

  get tripsTabActive() {
    return this.tripTabs.includes(this.$route.name);
  }

  get queryVehicleId() {
    return this.$route.query.vehicle || undefined;
  }
}
